<!--  -->
<template>
  <el-carousel v-if="articles&&articles.length>0" height="41px" indicator-position="outside" arrow="never" :autoplay="true">
    <el-carousel-item v-for="(article , index) in articles" :key="index">
      <div class="topews" >
        <h1 @click="$router.push(`/news/info/${article.plateid}/${article.uuid}`)">{{ article.title }}</h1>
        <!-- <div class="hengx"></div> -->
        <!-- <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ article.description }}</p> -->
      </div>
    </el-carousel-item>
  </el-carousel>
  
</template>

<script>
import {getTopNews} from '@/request/get'
import { IP_TEST } from '@/config';
export default {
  data () {
    return {
        articles:[],
        IP_TEST
    };
  },
  props:{
  },
  components: {},
  created(){
    this.getTopNews()
  },
  mounted(){},

  methods: {
   async getTopNews(){
    let result = await getTopNews();
    this.articles = result.data;
   },
  
  }
}

</script>
<style scoped>
.topews{
    background-color: #fff;
    min-height: 100px;
    text-align: center;
    padding:  0 30px 10px 30px;
}
.topews h1{
    font-size: 30px;
    line-height: 30px;
    font-weight: Bold;
    color: #2E8EEB;
    -webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
    /* display: -webkit-box; */
    height: 41px;
    cursor:pointer;
    overflow: hidden;
}
.topews .hengx{
    /* width: 1360px; */
    height: 0px;
    opacity: 1;
    border: 1px solid #999999;
    margin: 5px auto 11px;
}
.topews p {
    font-size: 18px;

font-weight: 400;
color: #333333;
line-height: 28px;
text-align: left;
word-break: break-all;
-webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    height: 31px;
    overflow: hidden;
    margin-top: 10px;
}
div >>>.el-carousel__indicators .el-carousel__indicator--horizontal button {
  width: 48px;
height: 4px;
background: #E9E9E9;
margin: 0 8px;
}
div >>>.el-carousel__indicators .is-active button{ 
background: #2E8EEB;
}
</style>